module.exports = __webpack_public_path__ + "static/media/ChunkFiveEx.56bdcded.woff";